import React from 'react';
import { Row, Col } from 'antd';

const Unauthorized401 = () => {
  return (
    <Row
      type="flex"
      align="middle"
      justify="center"
      style={{ minHeight: 'calc(100vh - 200px)' }}>
      <Col>
        <strong style={{ fontSize: '1.5rem' }}>Restricted Page | 401</strong>
      </Col>
    </Row>
  );
};

export default Unauthorized401;
